import { Controller } from "@hotwired/stimulus"

// A card in the seating chart's unassigned list: a guest (with their unseated
// plus-one shown inside, the two dropped onto a table together), or (plusOne)
// a plus-one whose guest is already seated. The identifier is
// the Sortable draggable selector and the values are read by
// table_card_controller when the card is dropped on a seat. Sortable itself
// handles draggability: a hard-coded draggable="true" would start a
// competing native browser drag alongside the styled fallback drag (see
// lib/drag_lift.js).
export default class extends Controller {
  static values = { id: Number, plusOne: Boolean }
}
